'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgRefresh } from '@common/icon';
import { captureException } from '@sentry/nextjs';
import type { ErrorInfo, ReactNode } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { ErrorBoundary } from 'react-error-boundary';
interface PolicyListErrorBoundaryProps {
  children: ReactNode;
}
const PolicyListErrorFallback = t0 => {
  const $ = _c(9);
  const {
    resetErrorBoundary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex size-64 items-center justify-center rounded-pill bg-gradient-to-br from-R-50 to-O-50"><svg className="size-32 text-R-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 3v6a1 1 0 001 1h6" /></svg></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="font-700 text-Gray-900 typo-body1">정책 목록을 불러올 수 없습니다</h2>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-center gap-12">{t1}<div className="flex flex-col items-center gap-8">{t2}<p className="text-center leading-relaxed text-Gray-600 typo-body3">일시적인 오류가 발생했어요<br />잠시 후 다시 시도하거나, 페이지를 새로고침 해주세요</p></div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgRefresh className="size-16 transition-transform duration-500 group-hover:rotate-180" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== resetErrorBoundary) {
    t5 = <Button type="button" onClick={resetErrorBoundary} theme="secondary-fill" dimensions="H40" className="group" aria-label={"\uC815\uCC45 \uBAA9\uB85D \uB2E4\uC2DC \uBD88\uB7EC\uC624\uAE30"}>{t4}다시 불러오기</Button>;
    $[4] = resetErrorBoundary;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-Gray-400 typo-caption1">문제가 계속되면 고객센터로 문의해주세요</p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <div className="mx-20 flex min-h-[calc(100vh-270px)] flex-col items-center justify-center gap-16 rounded-xlarge border border-Gray-200 bg-Gray-white px-20 py-80 animate-in fade-in-0" role="alert" aria-live="assertive">{t3}<div className="flex flex-col items-center gap-8">{t5}{t6}</div></div>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export const PolicyListErrorBoundary = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  const handleError = _temp;
  let t1;
  if ($[0] !== children) {
    t1 = <ErrorBoundary FallbackComponent={PolicyListErrorFallback} onError={handleError} onReset={_temp2}>{children}</ErrorBoundary>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(error, info) {
  captureException(error, {
    extra: {
      componentStack: info.componentStack
    }
  });
}
function _temp2() {
  window.location.reload();
}